(function ($) {
	"use strict";

	$(function () {

		var $menu = $(".location_map"),
			$menu_a = $("a", $menu),
			id = false,
			sections = [],
			$menu_menu = $(".js-menu-categories-wrapper"),
			$menu_menu_a = $("a", $menu_menu),
			id_menu = false,
			sections_menu = [],
			hash = function (h) {
				if (history.pushState) {
					history.pushState(null, null, h);
				} else {
					location.hash = h;
				}
			};

		$menu_a.click(function (event) {
			event.preventDefault();
			$("html, body").animate(
				{
					scrollTop: $($(this).attr("xlink\:href")).offset().top - $(".js-header").height() - 10
				},
				{
					duration: 700,
					complete: hash($(this).attr("xlink\:href"))
				}
			);
		});

		$('.js-location-button').click(function (event) {
			event.preventDefault();
			$("html, body").animate(
				{
					scrollTop: $($(this).attr("href")).offset().top - $(".js-header").height() - 10
				},
				{
					duration: 700,
					complete: hash($(this).attr("href"))
				}
			);
		});

		$('.js-mobile-offer-btn').click(function (event) {
			event.preventDefault();
			if ($('.location_map-wrapper').hasClass('opened')) {
				$('.js-mobile-location-map').trigger('click');
			}
			$("html, body").animate(
				{
					scrollTop: $($(this).attr("href")).offset().top
				},
				{
					duration: 700,
					complete: hash($(this).attr("href"))
				}
			);
		});

		if ($('.template__menu').length) {
			$menu_menu_a.click(function (event) {
				event.preventDefault();
				$("html, body").animate(
					{
						scrollTop: $($(this).attr("href")).offset().top - $(".js-sticky-inner").height() - 10
					},
					{
						duration: 700,
						complete: hash($(this).attr("href"))
					}
				);
			});

			$menu_menu_a.each(function () {
				sections_menu.push($($(this).attr("href")));
			});


			$.fn.ensureVisible = function () { $(this).each(function () { $(this)[0].scrollIntoView(); }); };


			$('.my-elements').ensureVisible();
			$(window).scroll(function (event) {
				var scrolling = $(this).scrollTop() + $(".js-sticky-inner").height() + 10
				var scroll_id;
				for (var i in sections_menu) {
					var section = sections_menu[i];
					if (scrolling > section.offset().top - 24) {
						scroll_id = section.attr("id");
					}
				}
				if (scroll_id !== id_menu) {
					id_menu = scroll_id;
					$menu_menu_a.parent().removeClass("active");

					$(`.${id_menu}`, $menu_menu).addClass("active");

					if (id_menu != undefined) {
						$(`.${id_menu}`).ensureVisible();
					}

				}
			});
		}


		$menu_a.each(function () {
			sections.push($($(this).attr("xlink\:href")));
		});



		$(window).scroll(function (event) {
			var scrolling = $(this).scrollTop() + $(this).height() / 3;
			var scroll_id;
			for (var i in sections) {
				var section = sections[i];
				if (scrolling > section.offset().top) {
					scroll_id = section.attr("id");
				}
			}
			if (scroll_id !== id) {
				id = scroll_id;
				$menu_a.parent().removeClass("active");

				$(`.${id}_g`, $menu).addClass("active");
			}
		});

	});
})(jQuery);

